var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIconLhotse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 332,
    viewBox: "0 0 629 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.566 331.9L581.99 276.212H264.467L316.105 214.854L279.655 171.519L191.972 276.212H119.274L243.407 127.981L207.159 84.6454L0 331.9H628.566Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.477 130.207L423.229 86.6693L316.105 214.853L352.353 258.188L459.477 130.207Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M386.981 43.3354L350.531 0L243.407 127.981L279.655 171.519L386.981 43.3354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconLhotse);
export default __webpack_public_path__ + "static/media/logo-icon-lhotse.572f07e8ec2109f9a91ccbb6b1e3ab83.svg";
export { ForwardRef as ReactComponent };